<div class="dialog-main">
    <div class="dialog">
        <div class="mat-dialog-actions" mat-dialog-actions [align]="selectedAlign">
            <button mat-button mat-dialog-close><mat-icon>close</mat-icon></button>
        </div>
        <h3>Kérem adja meg az akciós árat!</h3>
        <div class="text">
            <div class="input">
                <form novalidate [formGroup]="discountPriceForm!">
                    <input class="form-control" formControlName="discountPrice" id="discountPrice"
                        placeholder="Akciós ár" required type="number" />
                </form>
            </div>
        </div>
        <div class="submit">
            <button (click)="addDiscountPrice()">Akciós ár mentése</button>
        </div>
    </div>
</div>